(() => {
  const toggle = document.querySelector("[data-nav-toggle]");
  const nav = document.querySelector("[data-nav]");

  if (toggle && nav) {
    toggle.addEventListener("click", () => {
      const open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", String(open));
    });
  }

  // Collection sort — default newest first, submit on change
  const sortForm = document.querySelector("[data-collection-sort]");
  if (sortForm) {
    const defaultNewest = sortForm.dataset.defaultNewest === "true";
    const params = new URLSearchParams(window.location.search);

    if (defaultNewest && !params.has("sort_by")) {
      params.set("sort_by", "created-descending");
      const hash = window.location.hash || "";
      window.location.replace(`${window.location.pathname}?${params.toString()}${hash}`);
      return;
    }

    const select = sortForm.querySelector("select");
    if (select) {
      select.addEventListener("change", () => {
        const form = sortForm;
        const action = new URL(form.action, window.location.origin);
        if (window.location.pathname === "/" || window.location.pathname.endsWith("/")) {
          action.pathname = window.location.pathname;
        }
        form.action = `${action.pathname}${action.search}`;
        form.submit();
      });
    }
  }

  // Product variant sync
  const productRoot = document.querySelector("[data-product]");
  if (!productRoot) return;

  const jsonEl = document.querySelector("[data-product-json]");
  const variantInput = document.querySelector("[data-variant-id]");
  const priceEl = document.querySelector("[data-product-price]");
  const submitBtn = document.querySelector(".product-form__submit");
  const selects = [...productRoot.querySelectorAll(".product-form__select")];

  if (!jsonEl || !variantInput || selects.length === 0) return;

  let product;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch {
    return;
  }

  const findVariant = () => {
    const selected = selects.map((s) => s.value);
    return product.variants.find((v) =>
      v.options.every((opt, i) => opt === selected[i])
    );
  };

  const sync = () => {
    const variant = findVariant();
    if (!variant) return;
    variantInput.value = variant.id;
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? "Add to cart" : "Sold out";
    }
  };

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD",
      }).format(cents / 100);
    } catch {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  selects.forEach((s) => s.addEventListener("change", sync));
})();
